import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { DataResult } from '@progress/kendo-data-query';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Attachment } from 'src/app/_metronic/core/classes/core.class';
import { AppConstant } from 'src/app/app.constant';

@Injectable({
  providedIn: 'root'
})
export class PrincipalService {
  apiUrl: string;
  kendoDataUrl: string;

  constructor(private httpClient: HttpClient, private appConstant: AppConstant) {
    this.apiUrl = this.appConstant.getUrl();
    this.kendoDataUrl = this.apiUrl + 'GetAllPrincipalByInstituteIdKendo';
  }

  managePrincipal(principal) {
    return this.httpClient.post(`${this.apiUrl}/managePrincipal`, principal).pipe(
      map((response: any) => {
        return response;
      })
    )
  }


  getPrincipalById(pricnipalId) {
    return this.httpClient.get(`${this.apiUrl}/getPrincipalById/` + pricnipalId).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  
  addQualifications(types) {
    return this.httpClient.post(`${this.apiUrl}/manageQualification`, types).pipe(
      map((response: any) => {
        return response;
      })
    )
  }
  getAllQualifications() {
    return this.httpClient.get(`${this.apiUrl}/getAllQualification`).pipe(
      map((response: any) => {
        return response.data;
      })
    )
  }
  public getAllQualificationsKendo(): Observable<DataResult> {
    return this.httpClient.get(`${this.apiUrl}/getAllQualification/`).pipe(
      map((response: any) => {
        return {
          data: response.data,
          total: response.total
        } as GridDataResult
      })
    ) as any as Observable<GridDataResult>
  }
  getAllPrincipalExcel(reqData) {
    return new Promise((resolve, reject) => {
      return this.httpClient.post(`${this.apiUrl}/getAllPrincipal/`, reqData).pipe(
        map(res => res))
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }
  public getAllPrincipalKendo(reqData): Observable<DataResult> {
    return this.httpClient.post(`${this.apiUrl}/getAllPrincipal/`, reqData).pipe(
      map((response: any) => {
        return {
          data: response.data,
          total: response.total
        } as GridDataResult
      })
    ) as any as Observable<GridDataResult>
  }

  saveGridFilter(reqData) {
    return this.httpClient.post(`${this.apiUrl}/saveGridFilter`, reqData).pipe()
  }

  addAttachments(attachments: Attachment[]) {
    return new Promise((resolve, reject) => {
      this.httpClient.post(`${this.apiUrl}/fileBulkUpload`, attachments).pipe(
        map(res => res))
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  uploadProfilePicture(data) {
    return new Promise((resolve, reject) => {
      this.httpClient.post(`${this.apiUrl}/uploadProfilePicture`, data).pipe(
        map(res => res))
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }
}
